import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icons24 } from "../../Icons24Sprite/index.js";
import { IconWrapper } from "../../IconWrapper/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index44.css';const emptyState = "_emptyState_19h9u_1";
const iconContainer = "_iconContainer_19h9u_13";
const header = "_header_19h9u_24";
const caption = "_caption_19h9u_33";
const s = {
  emptyState,
  iconContainer,
  header,
  caption
};
const EmptyState = forwardRef(
  ({ children, className, header: header2, caption: caption2, iconName, ...rest }, ref) => /* @__PURE__ */ jsxs("div", { className: clsx(className, s.emptyState), ref, ...rest, children: [
    iconName && /* @__PURE__ */ jsx("span", { className: s.iconContainer, children: /* @__PURE__ */ jsx(IconWrapper, { size: "lg", children: /* @__PURE__ */ jsx(Icons24, { name: iconName }) }) }),
    /* @__PURE__ */ jsx("span", { className: s.header, children: header2 }),
    /* @__PURE__ */ jsx("span", { className: s.caption, children: caption2 }),
    children
  ] })
);
EmptyState.displayName = "DrawerEmptyState";
export {
  EmptyState
};
